<template>
    <div id="inviteManage">
        <my-header></my-header>
        <img style="margin-top: 80px;height: 140px;" src="../../assets/images/invitemanage/banner02.png" alt="" class="banner-image">
        <div class="main-container mainCon">
            <p class="location">您当前的位置：招标管理</p>
            <el-form class="invite-form" label-width="140px" ref="form" :model="form">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="招标项名称：">
                            <el-input size="medium" v-model="form.projectName" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" :offset="1">
                        <el-button class="btn-theme" size="medium"  icon="el-icon-search" @click="searchList">搜索</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <ul class="listContent" v-if="inviteMnList.length">
                <li v-for="(item,index) in inviteMnList" :key="index">
                    <div class="leftIndex">
                        <img :src='"../../assets/images/inviteList/0"+(index+1)+".png"'/>
                    </div>
                    <div class="rightText">
                        <h3>
                            <el-tooltip :content="item.formTitle" :disabled="item.formTitle.length<30" effect="light">
                                <strong @click="toDetail(item)">{{ item.formTitle }}</strong>
                            </el-tooltip>
                            <el-tag v-if="item.isText">{{ item.status }}</el-tag>
                            <span v-else class="ongoing" @click="toDetail(item)">{{ item.status }}</span>
                        </h3>
                        <p>最后修改日期：<span>{{ item.createDate }}</span></p>
                    </div>
                </li>
            </ul>
            <p v-else class="noResults">没有搜索结果</p>
            <!--   prev-text="上一页"
               next-text="下一页"-->
            <el-pagination
                :page-size="pager.pageSize"
                @current-change="handleCurrentChange"
                :current-page="pager.pageNum"
                :total="pager.total"
                layout="total, prev, pager, next"
                background
            >
            </el-pagination>
        </div>
        <my-footer></my-footer>
    </div>
</template>
<script>
    import MyHeader from './MasterHeader.vue'
    import MyFooter from '../common/Footer.vue'
    import axios from 'axios'
    export default {
        name: 'master-inviteManagement',
        data() {
            return {
                activeName: 'first',
                form: {
                    projectName: "",
                },
                pager:{
                    total: 0,
                    pageNum: 1,
                    pageSize: 8
                },
                inviteMnList:[],//招标管理列表数据
                statusList: []//状态数据
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            this.$root.activeIndex = 'win';
//            获取进行中，已定标，已流标等状态
            this.getStatus();
        },
        methods: {
            getStatus(){
                let _this = this;
                _this.$root.getHttp('/v1/sysDict/selectMap?type=tender_management_outer',function (res){
                    _this.statusList = res.data.data;
                    _this.getCurrentList(_this);//初始化招标管理列表数据
                });
            },
            getCurrentList(that){
                let obj = {};
                obj = {
                        "title": this.form.projectName,
                        "pageRequestVO": {
                            "pageFlag": 1,//1分页，0不分页
                            "pageNumber": that.pager.pageNum,
                            "pageSize": that.pager.pageSize,
                        }
                    };
                that.$root.postHttp('/v1/outerformflow/getBidManageData',obj,function (result) {
//                    console.log('列表',res)
                    that.pager.total = result.data.data.total;
                    that.inviteMnList = result.data.data.records || [];
                    that.inviteMnList.forEach((val,index) => {
                        let status = that.statusList[val.flowFormStatus];
                        if(val.abortiveFlag == 2) {
                            val.status = '已流标';
                            val.isText = true;
                        } else {
                            if(val.flowFormStatus == 1) {
                                if(val.flowFormSubStatus == 1){//1,待回复
                                    status = '回复邀请函';
                                    val.isText = false;
                                } else if(val.flowFormSubStatus == 2){// 2,已参与
                                    status = '已参与';
                                    val.isText = true;
                                } else {//3，不参与
                                    status = '不参与';
                                    val.isText = true;
                                }
                            } else {
                                val.isText = false;
                            }
                            val.status = status;
                        }
                     })
                })
            },
            toDetail(val){//到详情页。
//                console.log(val)
                this.$router.push('/master/processManagement/'+val.id);
            },
            handleCurrentChange (page) {
                this.pager.pageNum = page;
                this.getCurrentList(this);
            },
            searchList(){
                this.getCurrentList(this);
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/_var.scss";
    #inviteManage {
        background: #fff;
        & .head-top{
            background: #fff;
        }
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        & .mainCon {
            margin-top: 15px;
        }
        .location {
            padding-left: 15px;
            text-align: left;
            font-size: 12px;
            line-height: 42px;
            color: $--text-color-light;
            background: url('../../assets/images/inviteList/location.png') no-repeat left center;
        }
        .invite-form {
            background: $--primary-fill-color;
            .el-row {
                padding: 30px 0;
            }
            .el-form-item {
                margin: 0;
            }
            .btn-theme {
                background: $--primary-color;
            }
            .el-button:hover, .el-button:focus {
                background: #fae7eb;
            }
        }
        .listContent {
            margin-top: 30px;
            li {
                overflow: hidden;
                padding: 20px 0;
                border-bottom: 1px solid $--secondary-fill-color;
                .leftIndex {
                    float: left;
                    background-color: $--secondary-fill-color;
                    line-height: 80px;
                    text-align: center;
                    width: 80px;
                    color: $--primary-color;
                    img {
                        vertical-align: middle;
                    }
                }
                .rightText {
                    float: left;
                    width: 1090px;
                    margin-left: 30px;
                    h3 {
                        overflow: hidden;
                        line-height: 40px;
                        strong {
                            float: left;
                            max-width: 500px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-size: 18px;
                            color: $--text-color;
                            cursor: pointer;
                        }
                        strong:hover {
                            color: $--primary-color;
                            text-decoration: underline;
                        }
                        span {
                            float: right;
                            height: 30px;
                            width: 100px;
                            box-sizing: border-box;
                            border: 1px solid #4087e0;
                            border-radius: 15px;
                            line-height: 28px;
                            text-align: center;
                            font-size: 14px;
                            font-weight: normal;
                            color: $--text-color-lighter;
                            cursor: pointer;
                        }
                        .el-tag {
                            display: inline-block;
                            padding: 0px 10px;
                            height: 32px;
                            line-height: 30px;
                            font-size: 12px;
                            color: rgb(203, 18, 53);
                            border-radius: 4px;
                            box-sizing: border-box;
                            border: 1px solid rgba(203, 18, 53, 0.2);
                            white-space: nowrap;
                            cursor: not-allowed;
                        }
                        .ongoing {
                            color: #4087e0;
                        }
                        .ongoing:hover {
                            background-color: #4087e0;
                            color: #fff;
                        }
                        .textShow {
                            border: none;
                            color: #f60;
                        }
                    }
                    p {
                        padding-left: 22px;
                        text-align: left;
                        color: $--text-color-lighter;
                        font-size: 14px;
                        line-height: 50px;
                        background: url('../../assets/images/invitemanage/icon_text.png') no-repeat left center;
                        span {
                            color: $--text-color-light;
                        }
                    }
                }
            }
        }
        .noResults {
            font-size: 16px;
            color: #999;
            margin: 50px;
        }
        .el-pagination {
            margin: 50px 0 70px;
            text-align: right;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/master/ListManagement.vue